<template>
  <div class="degree-distribution-chart">
    <h3 class="text-center mb-4">{{ title }}</h3>
    <div class="row">
      <div class="col-md-6">
        <h4 class="text-center mb-3">Мэргэшсэн инженер</h4>
        <apexchart
          type="donut"
          :options="miningEngineerOptions"
          :series="miningEngineerSeries"
          height="350"
        />
      </div>
      <div class="col-md-6">
        <h4 class="text-center mb-3">Зөвлөх инженер</h4>
        <apexchart
          type="donut"
          :options="defenseEngineerOptions"
          :series="defenseEngineerSeries"
          height="350"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";

export default {
  name: "DegreeDistributionChart",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      miningEngineerSeries: [],
      miningEngineerOptions: {
        chart: {
          type: "donut"
        },
        labels: [],
        colors: ["#4299E1", "#FF69B4", "#48BB78", "#F6E05E"],
        legend: {
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Нийт",
                  formatter: () => {
                    return this.formatTotal(this.miningEngineerSeries);
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      },
      defenseEngineerSeries: [],
      defenseEngineerOptions: {
        chart: {
          type: "donut"
        },
        labels: [],
        colors: ["#4299E1", "#FF69B4", "#48BB78", "#F6E05E"],
        legend: {
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Нийт",
                  formatter: () => {
                    return this.formatTotal(this.defenseEngineerSeries);
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      }
    };
  },
  mounted() {
    this.loadData1();
    this.loadData2();
  },
  methods: {
    loadData1() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart1",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          // console.log(res);
          this.updateChartData(res.data, 1);
        }
      });
    },
    loadData2() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart2",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          // console.log(res);
          this.updateChartData(res.data, 2);
        }
      });
    },
    updateChartData(data, mode) {
      if (data && data.length > 0) {
        // Extract series data (counts)
        const series = data.map(item => parseInt(item[""]));

        // Extract labels with counts
        const labels = data.map(
          item => `${item.depart} (${parseInt(item[""]).toLocaleString()})`
        );

        // Update both charts with the same data
        if (mode == 1) {
          this.miningEngineerSeries = series;
          // Update entire options object to trigger reactivity
          this.miningEngineerOptions = {
            ...this.miningEngineerOptions,
            labels: labels
          };
        } else {
          this.defenseEngineerSeries = series;
          // Update entire options object to trigger reactivity
          this.defenseEngineerOptions = {
            ...this.defenseEngineerOptions,
            labels: labels
          };
        }
      }
    },

    formatTotal(series) {
      if (!series || series.length === 0) return "0";
      const total = series.reduce((sum, value) => sum + value, 0);
      return total.toLocaleString();
    }
  }
};
</script>

<style scoped>
.degree-distribution-chart {
  padding: 20px;
}
</style>
